import React from "react";
import { Box, Typography } from "@mui/material";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        textAlign: "center",
        padding: "20px",
        backgroundColor: "rgba(2,73,117, 0.1)",
      }}
    >
      <Typography variant="body1">
        © {new Date().getFullYear()} Drax Hall Orthopedics
      </Typography>
    </Box>
  );
};

export default Footer;
